import { LoadingOverlay, ModalProps } from "@mantine/core"
import { DefaultModal } from "../../../-components/default-modal"
import { useForm } from "@mantine/form"
import { CreateUpdateChatForm } from "./CreateUpdateChatForm"
import { showErrorNotification } from "../../../utils/form-submission-notifications"
import { useTranslation } from "react-i18next"
import { useQueryClient } from "@tanstack/react-query"
import { getGetChatByIdQueryKey, useUpdateChat } from "@/orval/gen"
import { ChatDto, UpdateChat } from "@/orval/gen/model"

interface Props extends ModalProps {
  chat: ChatDto
  readonly: boolean
}

export function UpdateChatModal({ chat, readonly, ...props }: Props) {
  const initialValues = {
    ...chat,
  }
  const form = useForm<Omit<UpdateChat, "chatId">>({
    mode: "controlled",
    initialValues,
  })

  React.useEffect(() => {
    form.setValues(initialValues)
  }, [chat])

  const queryClient = useQueryClient()
  const { mutateAsync, isPending } = useUpdateChat({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getGetChatByIdQueryKey({ chatId: chat.chatId }),
        })
        props.onClose()
      },
      onError: showErrorNotification,
    },
  })
  const handleSubmit = async (values: Omit<UpdateChat, "chatId">) => {
    await mutateAsync({ data: { ...values, chatId: chat.chatId } })
  }
  const { t } = useTranslation("app_server")

  return (
    <DefaultModal
      title={t(`ChatType_${form.getValues().chatType}`) + ": " + chat.name}
      {...props}
    >
      <LoadingOverlay visible={isPending} />
      <CreateUpdateChatForm
        readonly={readonly}
        form={form}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
      />
    </DefaultModal>
  )
}
